import componentLoader from '@/utils/componentLoader';
import React, { Suspense } from 'react';

import { LoadingScreen } from './components/loading-screen';
import ContactPage from './pages/ContactPage';
import DefaultPage from './pages/DefaultPage';
import FaqPage from './pages/FaqPage';
import ProductPage from './pages/ProductPage';

const loadComponent = (componentName: string) => {
  return React.lazy(() => componentLoader(() => import(`@/pages/${componentName}`)));
};

// Wrapper component
const LazyComponentLoader = ({
  componentName,
  ...props
}: {
  componentName: string;
  uri: string;
}) => {
  const Component = loadComponent(componentName);
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
};

type PropTypes = {
  uri: string;
  template: string;
};

function pageContent(uri: string, template: string) {
  switch (template) {
    case 'Contact Form Page Template':
      return <ContactPage uri={uri} />;
    case 'Default':
      return <DefaultPage uri={uri} />;
    case 'FAQ':
      return <FaqPage uri={uri} />;
    case 'Product':
      return <ProductPage uri={uri} />;
    default:
      return <LazyComponentLoader componentName="ErrorPage" uri={uri} />;
  }
}

const AppPageTemplate = ({ uri, template }: PropTypes) => pageContent(uri, template);

export default AppPageTemplate;
